import { lazy } from "react";
import { constants } from '../../../constants/constants';
const MonitoringPage = lazy(() => import('../../../../managers/monitoring/Monitoring'));

export const Monitoring = [
    {path: `/${constants.pages.monitoringUrl}/:buildingID`, component: MonitoringPage, exact: true},
];
